// const config = {
//   authority: "https://your-identity-provider.com", // Ganti dengan URL provider Anda
//   client_id: "your-client-id", // Ganti dengan client ID Anda
//   redirect_uri: "http://localhost:3000/callback", // Ganti dengan URL callback Anda
//   response_type: "id_token token",
//   scope: "openid profile email",
//   post_logout_redirect_uri: "http://localhost:3000/", // URL untuk redirect setelah logout
// };
const config = {
  authority: "https://sso-maritim.kemenhub.go.id/realms/djpl", // OIDC issuer (realm)
  client_id: "sitolaut", // Client ID from your OIDC provider
  redirect_uri: "https://sitolaut.dephub.go.id/callback", // Redirect URL for after login
  response_type: "code", // Use Authorization Code Flow
  scope: "openid profile", // Scopes
  post_logout_redirect_uri: "https://sso-maritim.kemenhub.go.id/login", // After logout redirection
  automaticSilentRenew: true, // Automatic token renewal
  serviceConfiguration: {
    authorizationEndpoint:
      "https://sso-maritim.kemenhub.go.id/realms/djpl/protocol/openid-connect/auth",
    tokenEndpoint:
      "https://sso-maritim.kemenhub.go.id/realms/djpl/protocol/openid-connect/token",
  },
};
// const config = {
//   authority: "https://sso-dev.hubla.dephub.go.id/realms/djpl", // OIDC issuer (realm)
//   client_id: "sitolaut", // Client ID from your OIDC provider
//   redirect_uri: "https://tollaut-barang.nutech-integrasi.com/callback", // Redirect URL for after login
//   response_type: "code", // Use Authorization Code Flow
//   scope: "openid profile", // Scopes
//   post_logout_redirect_uri: "https://tollaut-barang.nutech-integrasi.com/login", // After logout redirection
//   automaticSilentRenew: true, // Automatic token renewal
//   serviceConfiguration: {
//     authorizationEndpoint:
//       "https://sso-dev.hubla.dephub.go.id/realms/djpl/protocol/openid-connect/auth",
//     tokenEndpoint:
//       "https://sso-dev.hubla.dephub.go.id/realms/djpl/protocol/openid-connect/token",
//   },
// };

export default config;
